<template>
    <ul class="x-pro-ul" >

            <li class="x-pro-li"  v-for="pro in pro_items" >
                <router-link to="/production">
                    <div class="pro-img"><img :src="pro.url" alt=""></div>
                </router-link>
                <p class="x-pro-time"><span>小九</span>  2017-09-08</p>
                <h2 class="x-pro-title t-o-e-y">{{ pro.title }}</h2>
                <p class="x-pro-text t-o-e-n-3">{{ pro.text }}</p>
                <p class="x-pro-text t-o-e-n-3">项目请移至production</p>

            </li>

    </ul>
</template>

<script>
    export default {
        data(){
            return{
                pro_items: [
                    { url:'http://img3.imgtn.bdimg.com/it/u=1214593966,76569341&fm=27&gp=0.jpg',title:'个人博客',text:'个人博客正在努力开发中~~~~', },
                ]
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
.x-pro-ul{width: 1060px; margin: -30px 100px 0 50px; display: -webkit-flex; display: flex; flex-wrap:wrap;}
.x-pro-li{width: 300px;  margin-left: 50px; margin-top: 30px;}
.pro-img{width: 100%; height: 200px; border-box: none; border-radius: 10px; overflow: hidden; display: flex; justify-content: center; align-items:center; }
/*.x-pro-ul>.x-pro-li>.pro-img>img{position: absolute; left: 50%; top: 50%; }*/
/*.x-pro-ul>.x-pro-li>.pro-img>img{ width: 100%; height: 100%;}*/
.x-pro-time{width: 100%; text-align: left; color: #aaa; letter-spacing: 1px; margin-top: 10px; margin-bottom: 5px; font-weight: bold;}
.x-pro-time>span{color:#62bbc3; letter-spacing: 1px;}
.x-pro-title{width: 100%; text-align: left; color: #555; letter-spacing: 1px;}
.x-pro-text{width: 100%; text-align: left; color: #aaa; font-size: 16px; margin-top: 10px;}

/*S  项目图片放大 滤镜效果*/
.pro-img>img{
    filter: saturate(0%);  -webkit-filter: saturate(0%);
    transform: scale(1);
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.pro-img>img:hover{
    filter: saturate(100%);  -webkit-filter: saturate(100%);
    transform: scale(1.2);
}
/*E  项目图片放大 滤镜效果*/

/*S  项目框缩小*/
.pro-img{
    transform: scale(1);
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.pro-img:hover{
    filter: saturate(100%);  -webkit-filter: saturate(100%);
    transform: scale(.9);
}
/*E  项目框缩小*/


.x-pro-li>h2{
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.x-pro-li:hover h2{
    color: #62bbc3;
}

/*S 单行文本的溢出显示省略*/
.t-o-e-y{text-overflow:ellipsis; white-space:nowrap; overflow: hidden;}
/*E 单行文本的溢出显示省略*/

/*S 多行文本溢出显示省略号*/
.t-o-e-n-3{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
/*E 多行文本溢出显示省略号*/

/*S  屏幕小于880px*/
@media screen and (max-width: 1100px){
    .x-pro-ul{width: 700px; margin: 0 auto;}
}
/*E  屏幕小于880px*/

/*S  屏幕小于640px*/
@media screen and (max-width: 640px){
    .x-pro-ul{width: 100%; margin: 0 auto;}
    .x-pro-li{width: 90%; min-width: 400px; margin: 40px auto 0px; border: 1px solid #eee; border-radius: 20px; padding: 20px 10px;}
    .x-pro-li .pro-img{height: auto;}
    .pro-img>img{filter: saturate(100%);}
    .x-pro-title{color: #62bbc3}
}
/*E  屏幕小于640*/
</style>


// WEBPACK FOOTER //
// src/components/content/blog.vue